// extracted by mini-css-extract-plugin
export default {"wrapper":"Demographic_wrapper__JGOwk","contentCard":"Demographic_contentCard__kvRrH","chartRowWrapper":"Demographic_chartRowWrapper__I4Ms+"};